import React from "react";

import { faAngleRight, faCircleCheck } from "@performyard/fontawesome/pro-regular-svg-icons";
import { ButtonStandard, Icon, Text } from "@performyard/py-components";

export const CalendarCard = ({
	title,
	isConnected,
	isDisabled = false,
	onConnect,
	onDisconnect,
	onManage,
	icon,
	connectedCalendarName,
	showManageButton = true,
	isConnectedCalendarPrimary = false,
}: {
	title: string;
	isConnected: boolean;
	isDisabled?: boolean;
	onConnect: () => void;
	onDisconnect: () => void;
	onManage?: () => void;
	icon: React.ReactNode;
	connectedCalendarName?: string;
	showManageButton?: boolean;
	isConnectedCalendarPrimary?: boolean;
}) => {
	return (
		<div className="flex h-[56px] items-center rounded-lg p-4 outline outline-1 outline-neutral-2">
			<div className="flex w-full items-center justify-between gap-2">
				<div className="flex items-center gap-2">
					{/* Icon */}
					<div className="flex h-[48px] w-[48px] items-center justify-center">{icon}</div>

					{/* Title and Status */}
					<div>
						<Text size="paragraph-2" weight="semi-bold">
							{title}
						</Text>
						{isConnected ? (
							<div className="flex flex-row items-center">
								<Icon icon={faCircleCheck} size={16} color="green-7" />
								<Text size="caption" weight="regular" color="green-7">
									{connectedCalendarName || "Connected"}
									{isConnectedCalendarPrimary && <span className="text-neutral-6"> (Primary)</span>}
								</Text>
							</div>
						) : (
							<Text size="caption" weight="regular" color="neutral-5">
								Not Connected
							</Text>
						)}
					</div>
				</div>

				{/* Buttons */}
				{isConnected ? (
					<div className="flex flex-row items-center gap-2">
						<ButtonStandard
							size="small"
							color="red"
							variant="text"
							onClick={onDisconnect}
							data-testid="calendar-disconnect-button"
						>
							Disconnect
						</ButtonStandard>
						{showManageButton && (
							<ButtonStandard size="small" color="neutral" variant="text" onClick={onManage}>
								Manage
							</ButtonStandard>
						)}
					</div>
				) : (
					<div className="flex justify-end">
						<ButtonStandard
							size="small"
							iconRight={faAngleRight}
							color="primary"
							variant="text"
							disabled={isDisabled}
							onClick={onConnect}
							data-testid="calendar-connect-button"
						>
							Connect
						</ButtonStandard>
					</div>
				)}
			</div>
		</div>
	);
};
